import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import "../theme/navigation.css";
import * as routes from "../constants/routes";

class NavBar extends Component {
  static propTypes = {
    intl: PropTypes.shape({}).isRequired,
    forDetailer: PropTypes.bool
  };
  static defaultProps = {
    forDetailer: false
  };

  translateMessage = messageID => {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageID });
  };

  render() {
    const { forDetailer } = this.props;
    const regularLinks = [
      {
        href: "/how-it-works",
        title: this.translateMessage("NavBar.HowItWorks")
      },
      { href: routes.HOME, title: this.translateMessage("NavBar.Home") }
    ];
    const detailerLinks = [
      {
        href: routes.DETAILER_PACKAGES,
        title: this.translateMessage("NavBar.Packages")
      },
      {
        href: routes.DETAILER_PITCH,
        title: this.translateMessage("NavBar.Home")
      }
    ];
    const arrayToUse = forDetailer ? detailerLinks : regularLinks;
    const navHTML = arrayToUse.map(link => {
      const { href, title } = link;
      return (
        <li key={title}>
          <a href={href}>{title}</a>
        </li>
      );
    });

    return (
      <nav>
        <a className="homeLink" href="/">
          <img src={require("../images/logo_text_mcw.png")} alt="Mucky Duck" />
        </a>
        <ul id="navbar">{navHTML}</ul>
      </nav>
    );
  }
}

export default injectIntl(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBar.js